import { ServiceHistoryService } from 'api-new/generated';
import { QueryError, formatErrorMessage } from 'features/shared/model';
import { UseMutationOptions, useMutation } from 'react-query';
import { toast } from 'react-toastify';

type ServiceHistoryInitParams = {
  regNo?: string;
  vin?: string;
};

export const useServiceHistoryInitMutation = (
  options?: Omit<
    UseMutationOptions<
      Awaited<ReturnType<typeof ServiceHistoryService.postServiceHistoryInit>>,
      QueryError,
      ServiceHistoryInitParams,
      unknown
    >,
    'mutationFn'
  >
) =>
  useMutation(
    (input: ServiceHistoryInitParams) => ServiceHistoryService.postServiceHistoryInit(input.regNo, input.vin),
    {
      ...options,
      onError: (error: QueryError) => {
        const message = formatErrorMessage(error);
        toast.error(message);
        console.error(message);
      }
    }
  );
